module.exports = __webpack_public_path__ + "img/4.9e4c7c18.png";